// extracted by mini-css-extract-plugin
export var active = "_ca-2";
export var recordingDot = "_ca-1";
export var recordingIndicator = "_ca-0";